import { createFileRoute } from '@tanstack/react-router'

import { ActiveDrive } from '@/features/drives/active-drive'
import { handoverGate } from '@/features/handover/gate'

/** The drive that is happening, at `/bookings/{id}/active`. `sell` or above: `+15 min` is `SalesDep`. */
export const Route = createFileRoute('/_app/bookings/$bookingId_/active')({
  ...handoverGate(),
  component: ActiveDrive,
})
